// LedgerEntryRow — single row in a ledger entries table.
//
// Shared by:
//   - MerchantDetail (preview slice, latest few entries)
//   - MerchantLedger (full uncapped history page)
//
// Amount is shown as a signed currency value; debits render in warning red
// with a leading minus. amount_minor can arrive as number or bigint
// depending on json-bigint's threshold (Number.MAX_SAFE_INTEGER) — we
// coerce to bigint at the boundary so the math + formatter are uniform.
import { fmtCcyMinor, formatDateTime } from "@/utils/format";
import { LEDGER_KIND_LABEL, type LedgerEntry } from "@/api/merchantLedger";

export function LedgerEntryRow({ entry }: { entry: LedgerEntry }) {
  const amt = BigInt(entry.amount_minor);
  const positive = amt >= 0n;
  const abs = positive ? amt : -amt;
  return (
    <tr>
      <td className="dim" style={{ fontSize: 12 }}>
        {formatDateTime(entry.created_at)}
      </td>
      <td>
        {/* The human label, not the DB enum. A merchant reads this as a
            statement; "opening" beats "baseline" and "Fee" beats "fee". The
            wire value stays untouched. */}
        <span style={{ fontSize: 12 }}>
          {LEDGER_KIND_LABEL[entry.kind] ?? entry.kind}
        </span>
      </td>
      <td
        className="mono"
        style={{
          textAlign: "right",
          color: positive ? "inherit" : "var(--warn, #b42318)",
        }}
      >
        {positive ? "" : "−"}
        {fmtCcyMinor(abs, entry.currency)}
      </td>
      <td className="dim" style={{ fontSize: 12 }}>
        {entry.note ?? ""}
      </td>
    </tr>
  );
}
